interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`${isCenter ? "text-center mx-auto" : ""} max-w-2xl`}>
      <div
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium tracking-wide mb-4 ${
          light ? "bg-white/10 text-accent-200" : "bg-accent-100 text-accent-900"
        }`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
        {eyebrow}
      </div>
      <h2
        className={`font-heading font-bold text-2xl md:text-4xl leading-snug ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-sm md:text-base leading-relaxed ${light ? "text-background-200" : "text-foreground-600"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}